/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30Response } from './Oas30Response';

/**
 * Constructor.
 * @param {string} statusCode
 * @class
 * @extends Oas30Response
 * @author eric.wittmann@gmail.com
 */
export class Oas30ResponseDefinition extends Oas30Response implements IDefinition {
    public constructor(statusCode : string) {
        super(statusCode);
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasResponse#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitResponseDefinition(this);
    }
}
Oas30ResponseDefinition["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ResponseDefinition";
Oas30ResponseDefinition["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasHeaderParent","io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent","io.apicurio.datamodels.core.models.common.INamed"];




